<div class="wrapper-pricing-plan">
    <div class="section-main">
        <h1 class="title text-center">
            Find the <span class="text-blue">right plan</span> 
            for your new stores.

            <img class="yellow-line" src="../../assets/yellow-line.png" alt="line">
        </h1>
        <p class="subtitle text-center">Curabitor vehicula libero non iaculis pellentesque.</p>
        <div class="d-flex justify-content-center">
            <button (click)="goToSignUp()" class="btn btn-create rounded-pill">
                Setup New Store
            </button>
        </div>
    </div>

    <div class="bg-curve"></div>

    <div class="section-plans">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-6 col-lg-4 card-container">
                <div class="card">
                    <h3 class="card-title">Starter</h3>
                    <div class="row card-price mx-auto">
                        <p class="price-sign">$</p>
                        <h1 class="price-amount">0</h1>
                        <p class="price-month">/mo</p>
                    </div>
                    <p class="card-subtitle">Free Plan Forever</p>
                    <p class="card-info">Easy online store to launch your business for free</p>
                    <button class="btn btn-choose rounded-pill">Choose</button>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-4 card-container">
                <div class="card">
                    <h3 class="card-title">Essentials</h3>
                    <div class="row card-price mx-auto">
                        <p class="price-sign">$</p>
                        <h1 class="price-amount">15</h1>
                        <p class="price-month">/mo</p>
                    </div>
                    <p class="card-subtitle">$12.50/mo paid annually</p>
                    <p class="card-info">Easy online store to launch your business for free</p>
                    <button class="btn btn-choose rounded-pill">Choose</button>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-4 card-container">
                <div class="card">
                    <h3 class="card-title">Premium</h3>
                    <div class="row card-price mx-auto">
                        <p class="price-sign">$</p>
                        <h1 class="price-amount">35</h1>
                        <p class="price-month">/mo</p>
                    </div>
                    <p class="card-subtitle">$29.17/mo paid annually</p>
                    <p class="card-info">Easy online store to launch your business for free</p>
                    <button class="btn btn-choose rounded-pill">Choose</button>
                </div>
            </div>
        </div>
    </div>

    <div class="section-features container-xl">
        <h6 class="section-subtitle">Comparison</h6>
        <h1 class="section-title">Compare features</h1>

        <div class="table-features table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th class="border-left-0 text-start w-44 px-4 pb-5" scope="col">
                            <p>Plan</p> 
                        </th>
                        <th class="border-left-0 text-center d-flex flex-column" scope="col">
                            Starter
                            <div class="d-flex justify-content-center">
                                <button class="btn btn-select rounded-pill">
                                    Select
                                </button>
                            </div>
                        </th>
                        <th class="border-left-0 text-center" scope="col">
                            Essentials
                            <div class="d-flex justify-content-center">
                                <button class="btn btn-select rounded-pill">
                                    Select
                                </button>
                            </div>
                        </th>
                        <th class="border-right-0 text-center" scope="col">
                            Premium
                            <div class="d-flex justify-content-center">
                                <button class="btn btn-select rounded-pill">
                                    Select
                                </button>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="border-left-0 text-start px-4">Transaction Fee</td>
                        <td class="text-center">None</td>
                        <td class="text-center">None</td>
                        <td class="border-right-0 text-center">None</td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">Product limit</td>
                        <td class="text-center">10</td>
                        <td class="text-center">100</td>
                        <td class="border-right-0 text-center">2,500</td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">Categories</td>
                        <td class="text-center">Unlimited</td>
                        <td class="text-center">Unlimited</td>
                        <td class="border-right-0 text-center">Unlimited</td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">Storage</td>
                        <td class="text-center">Unlimited</td>
                        <td class="text-center">Unlimited</td>
                        <td class="border-right-0 text-center">Unlimited</td>
                    </tr>
                    <tr class="bg-gray">
                        <th class="text-start px-4">Shopping Experience</th>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Adaptive Storefront Widget (desktop, tablet, mobile)
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Favorites/Wishlist
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Single product widgets
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Faceted search and product display filters: by 
                            keywords, attributes, price range, category
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Product already in cart are marked in product list, making
                            shopping easier
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Real-time shipping estimates based on customer IP
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Customer can create profile or checkout without creating
                            profile (configurable)
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Address book for customers with profiles
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Media rich category and product descriptions
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Accept the Terms and Conditions before ordering
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Next/Previous product navigation links
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Automatic price adjustment for product options
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Fast content delivery with CDN
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr class="bg-gray">
                        <th class="text-start px-4">Catalog Management</th>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Built-in storefront translations
                        </td>
                        <td class="text-center">
                            45
                        </td>
                        <td class="text-center">
                            45
                        </td>
                        <td class="border-right-0 text-center">
                            45
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Built-in backend translations
                        </td>
                        <td class="text-center">
                            15
                        </td>
                        <td class="text-center">
                            15
                        </td>
                        <td class="border-right-0 text-center">
                            15
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Inventory tracking
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Product options (Drop-down, Radio Buttons, Text, Date Picker,
                            File, Checkboxes)
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Stock control for options & product combinations
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            E-goods
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            E-goods max size
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            100 Mb
                        </td>
                        <td class="border-right-0 text-center">
                            100 Mb
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            E-goods download protection
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Customer can attach files to orders
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Image gallery
                        </td>
                        <td class="text-center">
                            Unlimited
                        </td>
                        <td class="text-center">
                            Unlimited
                        </td>
                        <td class="border-right-0 text-center">
                            Unlimited
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            WYSIWYG editor for HTML product descriptions
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Automatic thumbnail generation with image sharpening
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Product can be in more than one category
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Product types and attributes
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Product filters
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Product dimensions
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Multi-currency support
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr class="bg-gray">
                        <th class="text-start px-4">Shipping and Tax</th>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Delivery zones
                        </td>
                        <td class="text-center">
                            Unlimited
                        </td>
                        <td class="text-center">
                            Unlimited
                        </td>
                        <td class="border-right-0 text-center">
                            Unlimited
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Shipping configuration wizard 
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Automatic tax calculations for US, Canada, UK, EU, Australia
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Manually conﬁgurable Shipping/Tax zones, rates and rules
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Tax exempt customers
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            VAT reverse charge
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Realtime shipping quotes for UPS, USPS, FedEx, Canada Post, 
                            EMS Russian Post, Correios and Australia Post
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Use real time quotes without setting account with carrier
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Realtime shipment tracking
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            In-Store order pickup
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Handling fees
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr class="bg-gray">
                        <th class="text-start px-4">Promotions</th>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Discount coupons
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Volume discounts and multi-tier prices
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Sale and promotional price
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Discounts for customer groups
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Facebook Like buttons
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Facebook comments
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Share purchase on Facebook, Twitter
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Share product on Facebook, Pinterest, Twitter, Google+, Tumblr
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Ask friends
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Basic affiliate features
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr class="bg-gray">
                        <th class="text-start px-4">Integrations</th>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Facebook Shop
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Sell on Instagram
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Sell on Amazon
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Facebook Messenger integration
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Google Shopping Feeds
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Remarketing with Google Analytics
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Third-party integrations for Amazon and eBay (paid)
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Square POS
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="border-right-0 text-center">
                            &nbsp;
                        </td>
                    </tr>
                    <tr class="bg-gray">
                        <th class="text-start px-4">User Experience</th>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Interactive Onboarding Wizard
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr class="bg-gray">
                        <th class="text-start px-4">Orders</th>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Customizable e-mail notiﬁcations
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Order history for customers and administrator
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Order email notiﬁcations to multiple recipients
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Edit / create orders
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Track payment and shipping status
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Customer IP in order details
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Warning if IP is different from billing country
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Automatic abandoned cart recovery
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Invoice printing
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Bulk invoice printing
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Edit Invoice
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Order comments ﬁeld
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Conﬁgurable min/max order amount limits
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Staff order notes
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Low stock notiﬁcation
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Set next order number
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr class="bg-gray">
                        <th class="text-start px-4">Data Management</th>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            CSV export for order, product and customer data
                        </td>
                        <td class="text-center">
                            &nbsp;
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            CSV import for product data
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Conﬁgurable measurement units, date/time formats and currency symbol.
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr class="bg-gray">
                        <th class="text-start px-4">Store Design Customization</th>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Customizable CSS design schemes
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr class="bg-gray">
                        <th class="text-start px-4">SEO</th>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Direct indexing by Google
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            SEO ﬁelds for products
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr class="bg-gray">
                        <th class="text-start px-4">Tracking and Reporting</th>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Tracking and e-commerce reporting with Google Universal Analytics
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Custom tracking code on "Thank you for your order" page
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr class="bg-gray">
                        <th class="text-start px-4">Payment Options</th>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Offline Payments
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            PayPal Standard, PayPal Express Checkout, PayPal Advanced and 
                            PayPal Payﬂow Link, PayPal Payments Pro Hosted, PayPal Bill Me Later
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Stripe
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            2Checkout
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            American Express Payment Gateway
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Authorize.Net SIM
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Bancomer
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Beanstream (Hosted Payment Form)
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            e-Path
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            eWAY (Hosted Payment Page)
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            First Data Global Gateway e4
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            iDEAL (via Mollie)
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            iPay88
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            iPayment
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Mollie (Visa, MasterCard, American Express, Bancontact, iDeal, KBC, 
                            Belﬁus, Bitcoin and PayPal)
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Moneris SELECTplus (Hosted Paypage)
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            MultiSafepay ( iDEAL, credit cards, Giropay, Bancontact DIRECTebanking/ SOFORT)
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Network Merchants
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Pag Seguro
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Payeezy
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            PayFast
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            PayJunction
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            PayLeap
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            PayOnline System
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Paytrail (former Suomen Verkkomaksut Oy)
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            PayU Biz: India
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            PayU Money: India
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            QIWI
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Realex Payments / Global Iris
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Robokassa (Webmoney, Yandex.Money, etc)
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Sage Exchange US
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Sage Pay UK
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Sberbank
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            TransFirst Transaction Express
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Virtual Cart Services
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start px-4">
                            Yandex Kassa
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                        <td class="border-right-0 text-center">
                            <img src="../../assets/icon/checkmark_green.png" alt="check">
                        </td>
                    </tr>

                    <tr>
                        <td class="border-left-0">&nbsp;</td>
                        <td>
                            <div class="d-flex justify-content-center">
                                <button class="btn btn-select rounded-pill mb-20">
                                    Select
                                </button>
                            </div>
                        </td>
                        <td>
                            <div class="d-flex justify-content-center">
                                <button class="btn btn-select rounded-pill mb-20">
                                    Select
                                </button>
                            </div>
                        </td>
                        <td class="border-right-0">
                            <div class="d-flex justify-content-center">
                                <button class="btn btn-select rounded-pill mb-20">
                                    Select
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="section-faq">
        <div class="card">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-5">
                    <p class="card-faq">FAQ</p>
                    <h1 class="card-title">Have any questions?</h1>
                    <p class="card-subtitle">
                        Curabitor vehicula libero non iaculis
                        pellentesque. Nullam dignissim dignissim ligula,
                        sed blandit lorem rhonces vel. Donec posuere
                        diam vitae orci scelerisque, quis congue urna porta.
                    </p>
                    <div class="section-btn">
                        <button class="btn btn-contact rounded-pill mb-20">
                            Contact Us
                        </button>
                    </div>
                </div>
                <div class="section-cards col-12 col-sm-12 col-md-12 col-lg-8 col-xl-7">
                    <div class="card card-white">
                        <div (click)="toggleAnswer(1)" class="row card-contents">
                            <div class="w-10">
                                <img *ngIf="!answer1" class="plus-icon" src="../../assets/icon/plus-icon.png" alt="plus">
                                <img *ngIf="answer1" class="minus-icon" src="../../assets/icon/minus-icon.png" alt="minus">
                            </div>
                            <div class="w-90">
                                <p [className]="!answer1 ? 'card-text' : 'card-text-yellow'">Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
                            </div>
                        </div>
                        <div [@collapse]="!answer1">
                            <p class="card-info">
                                Curabitur vehicula libero non iaculis pellentesque. Nullma dignissim
                                dignissim ligula, sed blandit lorem rhonces vel. Donec posuere diam
                                vitae orci scelerisque, quis congue urna porta.
                            </p>
                        </div>
                    </div>
                    <div class="card card-white mt-3">
                        <div (click)="toggleAnswer(2)" class="row card-contents">
                            <div class="w-10">
                                <img *ngIf="!answer2" class="plus-icon" src="../../assets/icon/plus-icon.png" alt="plus">
                                <img *ngIf="answer2" class="minus-icon" src="../../assets/icon/minus-icon.png" alt="minus">
                            </div>
                            <div class="w-90">
                                <p [className]="!answer2 ? 'card-text' : 'card-text-yellow'">Cras cursus nibh sit amet velit euismod?</p>
                            </div>
                        </div>
                        <div [@collapse]="!answer2">
                            <p class="card-info">
                                Curabitur vehicula libero non iaculis pellentesque. Nullma dignissim
                                dignissim ligula, sed blandit lorem rhonces vel. Donec posuere diam
                                vitae orci scelerisque, quis congue urna porta.
                            </p>
                        </div>
                    </div>
                    <div class="card card-white mt-3">
                        <div (click)="toggleAnswer(3)" class="row card-contents">
                            <div class="w-10">
                                <img *ngIf="!answer3" class="plus-icon" src="../../assets/icon/plus-icon.png" alt="plus">
                                <img *ngIf="answer3" class="minus-icon" src="../../assets/icon/minus-icon.png" alt="minus">
                            </div>
                            <div class="w-90">
                                <p [className]="!answer3 ? 'card-text' : 'card-text-yellow'">Cras cursus nibh sit amet velit euismod?</p>
                            </div>
                        </div>
                        <div [@collapse]="!answer3">
                            <p class="card-info">
                                Curabitur vehicula libero non iaculis pellentesque. Nullma dignissim
                                dignissim ligula, sed blandit lorem rhonces vel. Donec posuere diam
                                vitae orci scelerisque, quis congue urna porta.
                            </p>
                        </div>
                    </div>
                    <div class="card card-white mt-3">
                        <div (click)="toggleAnswer(4)" class="row card-contents">
                            <div class="w-10">
                                <img *ngIf="!answer4" class="plus-icon" src="../../assets/icon/plus-icon.png" alt="plus">
                                <img *ngIf="answer4" class="minus-icon" src="../../assets/icon/minus-icon.png" alt="minus">
                            </div>
                            <div class="w-90">
                                <p [className]="!answer4 ? 'card-text' : 'card-text-yellow'">Cras cursus nibh sit amet velit euismod?</p>
                            </div>
                        </div>
                        <div [@collapse]="!answer4">
                            <p class="card-info">
                                Curabitur vehicula libero non iaculis pellentesque. Nullma dignissim
                                dignissim ligula, sed blandit lorem rhonces vel. Donec posuere diam
                                vitae orci scelerisque, quis congue urna porta.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center">
                <button class="btn btn-outline-primary rounded-pill">
                    More info
                </button>
            </div>
        </div>
    </div>

    <div class="section-payment container px-4">
        <h6 class="section-subtitle">Payment method</h6>
        <h1 class="section-title">We accept various payment</h1>

        <div class="payment-method d-flex justify-content-center">
            <div class="row mt-5">
                <div class="col-4 col-sm-4 col-md-2">
                    <img class="payment-logo" src="../../assets/payment-logo/Stripe.png" alt="stripe">
                </div>
                <div class="col-4 col-sm-4 col-md-2">
                    <img class="payment-logo" src="../../assets/payment-logo/Visa.png" alt="visa">
                </div>
                <div class="col-4 col-sm-4 col-md-2">
                    <img class="payment-logo" src="../../assets/payment-logo/PayPal.png" alt="paypal">
                </div>
                <div class="col-4 col-sm-4 col-md-2">
                    <img class="payment-logo" src="../../assets/payment-logo/Mastercard.png" alt="mastercard">
                </div>
                <div class="col-4 col-sm-4 col-md-2">
                    <img class="payment-logo" src="../../assets/payment-logo/ApplePay.png" alt="apple">
                </div>
                <div class="col-4 col-sm-4 col-md-2">
                    <img class="payment-logo" src="../../assets/payment-logo/GooglePay.png" alt="google">
                </div>
            </div>
        </div>
    </div>

    <div class="divider"></div>

    <div class="section-inspire container-xl">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-5 image-container">
                <img class="person-image" src="../../assets/person.png" alt="person">
            </div>
            <div class="col-12 col-sm-12 col-md-7 text-container">
                <h3 class="subtitle">Be inspired, and inspire others</h3>
                <h1 class="title">1,330,889,000</h1>
                <p class="info">Our merchants made USD in sales</p>
            </div>
        </div>
    </div>

    <div class="section-cta container-xl">
        <div class="card">
            <div class="section-top">
                <img class="ellipse-yellow" src="../../assets/ellipse-yellow.png" alt="yellow">
            </div>
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                    <h4 class="card-title">FIV5S - Make You Possible</h4>
                    <p class="card-subtitle">An eco-platform app to manage your business which solves all your business challenges.</p>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 section-btn">
                    <button (click)="goToSignUp()" class="btn btn-create rounded-pill mb-20">
                        Setup New Store
                    </button>
                </div>
            </div>
            <div class="section-bottom">
                <img class="ellipse-blue" src="../../assets/ellipse-blue.png" alt="blue">
            </div>
        </div>
    </div>
</div>